import React from 'react'
import cx from 'classnames'
import type { ClassValue } from 'classnames/types'

type ActionBarProps = {
    children?: any
    className?: ClassValue
}

export const ActionBar = ({ children, className }: ActionBarProps) => {
    const classNames = cx(
        'action-bar sticky top-0 z-20 px-2 py-0 bg-white border-b border-gray-200',
        className,
    )

    return <div className={classNames}>{children}</div>
}
